import style from './components/style';
import menu from './components/menu';
import carousel from './components/carousel';

function initHiPriorityCommon() {
	style.init();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
	menu.init();
	carousel.init();
}

// document.addEventListener( 'DOMContentLoaded', function () {
window.utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
